import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../../constants/responsiveClassNames';
import { useContainerWidth } from '../../../hooks/useContainerWidth';

const ListsNullView = ({ componentId, isDashboardSnapshot }) => {
  const [containerRef, containerWidth] = useContainerWidth();
  const { ref: impressionRef, clickID } = useImpression({
    data: {
      component: 'Lists',
      name: 'ListsNullState',
      id: 'ListsNull',
      position: 1,
      type: 'content'
    }
  });

  const mergedRef = useCallback((node) => {
    containerRef.current = node;
    if (typeof impressionRef === 'function') {
      impressionRef(node);
    } else if (impressionRef) {
      impressionRef.current = node;
    }
  }, [containerRef, impressionRef]);

  return (
    <div
      className="sui-@container sui-h-full"
      data-testid="lists-null-view"
      ref={mergedRef}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <div
        id="lists-compact-null-view"
        className={classNames(showBelowSmBreakpoint)}
      >
        <CompactNullView
          clickID={clickID}
          isDashboardSnapshot={isDashboardSnapshot}
        />
      </div>
      <div
        id="lists-desktop-null-view"
        className={classNames(showAboveSmBreakpoint, 'sui-h-full')}
      >
        <DesktopNullView containerWidth={containerWidth} isDashboardSnapshot={isDashboardSnapshot} />
      </div>
    </div>
  );
};

ListsNullView.propTypes = {
  componentId: PropTypes.string,
  isDashboardSnapshot: PropTypes.bool
};

ListsNullView.defaultProps = {
  componentId: '',
  isDashboardSnapshot: false
};

export default ListsNullView;
